import styled from 'styled-components';
import algoliasearch from 'algoliasearch';
import { rem } from 'polished';
import React, { useState } from 'react';
import {
  Configure,
  connectHits,
  Highlight,
  Index,
  InstantSearch,
  SearchBox,
} from 'react-instantsearch-dom';
import 'instantsearch.css/themes/reset.css';
import { __ } from '../../Utils';
import { connect } from '../../Store';

const algoliaClient = algoliasearch(
  'LEJSC78YKP',
  '2e962d15f3e7cf90baa4a73de9465984',
);

const Search = ({
  show,
  configuration,
  onHitClick = () => {},
  onSubmit = () => {},
}) => {
  const [searchState, setSearchState] = useState({
    query: '', //shared state between all indices
    indices: {
      products_query_suggestions_external_analytics_query_suggestions: {
        configure: {
          hitsPerPage: 1,
        },
      },
      xfarby_eshop_categories: {
        configure: {
          hitsPerPage: 1,
        },
      },
      b2b_products_small: {
        configure: {
          hitsPerPage: 4,
        },
      },
    },
  });

  const updateSearchState = newStateQuery => {
    setSearchState({
      ...searchState,
      query: newStateQuery,
    });
  };

  if (show)
    return (
      <Wrapper top={configuration && configuration.top}>
        <SearchWindow>
          <InstantSearch
            searchClient={algoliaClient}
            indexName="b2b_products_small_sk"
            searchState={searchState}
            onSearchStateChange={state => updateSearchState(state.query)}
          >
            <SearchBoxWrapper>
              <SearchBox
                autoFocus
                // submit={<FontAwesomeIcon size="md" icon={['fas', 'search']} />}
                // reset={<FontAwesomeIcon icon={['fas', 'times']} />}
                translations={{
                  submitTitle: '',
                  resetTitle: __('Zrušiť'),
                  placeholder: __('Vyhľadať'),
                }}
                onSubmit={e => {
                  e.preventDefault();
                  if (searchState.query.length > 2) {
                    onSubmit(searchState.query);
                  }
                }}
              />
            </SearchBoxWrapper>

            <Index indexName="products_query_suggestions_external_analytics_sk">
              <Configure
                hitsPerPage={
                  (configuration && configuration.suggestionsHitsPerPage) || 3
                }
              />
              <div className="suggestionsHits">
                <SuggestionsHits
                  updateSearchState={updateSearchState}
                  searchStateQuery={searchState.query}
                />
              </div>
            </Index>

            <Index indexName="b2b_products_small_sk">
              <Configure
                filters="published:true"
                hitsPerPage={
                  (configuration && configuration.productsHitsPerPage) || 6
                }
              />
              <div
                className={`${
                  searchState.query.length > 2
                    ? 'suggestionsHits'
                    : 'suggestionsHitsLast'
                } `}
              >
                <ProductHits onHitClick={onHitClick} />
              </div>
            </Index>
          </InstantSearch>
        </SearchWindow>
      </Wrapper>
    );
  else {
    if (searchState.query !== '') {
      updateSearchState('');
    }
  }

  return <div />;
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Search);

// const ShowMore = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   padding: ${rem(24)};
//   font-size: ${rem(14)};
//   color: ${props => props.theme.color.primaryTextColor};
//   font-weight: bold;
//   text-decoration: underline;
// `;

const Wrapper = styled.div`
  position: absolute;
  width: max-content;
  top: ${props => props.top || '72px'};
  left: 0px;
  @media (min-width: ${rem(750)}) {
    width: 100%;
    left: 0px;
    top: ${props => props.top || '-8px'};
  }

  /* height: 100%; */
  z-index: 100;
`;

const SearchWindow = styled.div`
  .empty-area {
    width: 100%;
    height: 100%;
  }

  .suggestionsHits {
    position: relative;
    .ais-Hits .ais-Hits-list {
      .ais-Hits-item {
        :first-of-type {
          padding-top: ${rem(12)};
        }
      }

      .ais-Hits-item {
        :last-of-type {
          /* background-color: yellow; */
          border-bottom: ${rem(2)} solid #DEDFE0;
          padding-bottom: ${rem(12)};
        }
      }
    }
  }

  .suggestionsHitsLast {
    position: relative;
    .ais-Hits .ais-Hits-list {
      .ais-Hits-item {
        :first-of-type {
          padding-top: ${rem(12)};
        }

        :last-of-type {
          padding-bottom: ${rem(12)};
        }
      }
    }
  }

  position: relative;
  z-index: 99;
  width: 100%;
  overflow: hidden;
  border-radius: ${rem(0)};
  @media (min-width: ${rem(750)}) {
    border-radius: ${rem(24)};
    border: ${rem(1)} solid #DEDFE0;
  }
  box-shadow: ${rem(0)} ${rem(20)} ${rem(20)} rgba(0, 0, 0, 0.1);
  /* color: ${props => props.theme.color.primaryTextColor}; */
  background: white;
  border-bottom: none;
  top: ${rem(8)};

  .ais-Hits-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .ais-Pagination-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;

    .ais-Pagination-item {
      padding: ${rem(8)};
    }
  }
`;

const SearchBoxWrapper = styled.div`
  .ais-SearchBox-form {
    width: 100%;
    /* color: ${props => props.theme.color.primaryTextColor}; */
  }

  .ais-SearchBox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .ais-SearchBox-input {
      width: 100%;
      position: relative;
      height: ${rem(48)};
      padding-left: ${rem(80)};
      padding-right: ${rem(80)};
      font-size: ${rem(14)};
      z-index: 100;
      border: none;
      border-bottom: ${rem(2)} solid #DEDFE0;

      border-radius: ${rem(0)};
      @media (min-width: ${rem(750)}) {
        border-radius: ${rem(16)} ${rem(16)} 0 0;
      }

      /* background: green; */

      :focus {
        outline: none;
      }
    }

    .ais-SearchBox-submit {
      cursor: default;
      z-index: 101;
      position: absolute;
      top: ${rem(14)};
      left: ${rem(32)};
    }

    .ais-SearchBox-reset {
      z-index: 101;
      position: absolute;
      top: ${rem(14)};
      right: ${rem(32)};
    }
  }
`;

const SuggestionHit = props => {
  return (
    <div className="ais-Hits">
      <ol className="ais-Hits-list">
        {props.hits.map(hit => {
          if (hit.query === props.searchStateQuery) {
            return <div />;
          } else
            return (
              <li className="ais-Hits-item">
                <div>
                  <HitWrapper
                    onClick={() => props.updateSearchState(hit.query)}
                  >
                    <div className="left-side">
                      <div className="hit-icon">
                        {/* <FontAwesomeIcon size="md" icon={['fas', 'search']} /> */}
                      </div>
                      <div className="name">
                        <Highlight
                          className="suggestion-highlight"
                          attribute="query"
                          hit={hit}
                        />
                      </div>
                    </div>

                    <div className="category">
                      {/* <FontAwesomeIcon
                        className="suggestion-icon"
                        size={'md'}
                        icon={['fas', 'arrow-right-long']}
                      /> */}
                    </div>
                  </HitWrapper>
                </div>
              </li>
            );
        })}
      </ol>
    </div>
  );
};

const SuggestionsHits = connectHits(SuggestionHit);

const ProductHit = ({ hits, onHitClick, history }) => {
  return (
    <div className="ais-Hits">
      <ol className="ais-Hits-list">
        {hits.map(hit => {
          return (
            <li className="ais-Hits-item">
              {/* <Link
                href={`${getTranslatedPath('product', null, lang)}/${
                  hit.product_url
                }`}
              > */}
              <a onClick={() => onHitClick(hit.objectID)}>
                <HitWrapper>
                  <div className="left-side">
                    <div className="hit-picture">
                      {hit.title_image && (
                        <img src={`${hit.title_image}`} alt={hit.name} />
                      )}
                    </div>

                    <div className="name">
                      <Highlight
                        className="hit-highlight"
                        attribute="name"
                        hit={hit}
                      />
                    </div>
                  </div>
                  <div className="right-side">
                    <div className="categoryDummy">
                      <Highlight
                        className="hit-highlight"
                        attribute="categories[0]"
                        hit={hit}
                      />
                    </div>
                  </div>
                </HitWrapper>
              </a>
              {/* </Link> */}
            </li>
          );
        })}
      </ol>
    </div>
  );
};

const ProductHits = connectHits(ProductHit);

const HitWrapper = styled.div`
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${rem(8)} ${rem(16)} ${rem(8)} ${rem(16)};
  flex-direction: row;
  width: 100%;

  :hover {
    cursor: pointer;

    .name {
      text-decoration: underline;
    }
  }

  @media (min-width: ${rem(300)}) {
    padding: ${rem(8)} ${rem(32)} ${rem(8)} ${rem(16)};
  }

  .full-width {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
  }

  .left-side {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 80%;
  }

  .right-side {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 20%;
  }

  .suggestion-highlight {
    .ais-Highlight-highlighted {
      font-weight: 300;
    }

    .ais-Highlight-nonHighlighted {
      font-weight: bold;
    }
  }

  .name {
    white-space: nowrap;
    font-size: ${rem(14)};
    width: ${rem(250)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (min-width: ${rem(750)}) {
      width: unset;
    }
  }

  .hit-description-wrapper {
    max-width: ${rem(250)};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .ais-Highlight-highlighted {
    font-weight: bold;
    font-style: normal;
  }

  .hit-picture {
    height: ${rem(48)};
    width: ${rem(48)};
    min-width: ${rem(48)};
    margin-right: ${rem(16)};
    display: flex;
    justify-content: flex-start;
    align-items: center;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  .hit-icon {
    width: ${rem(48)};
    min-width: ${rem(48)};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: ${rem(16)};
  }

  .category,
  .categoryDummy {
    max-width: 150px;
    width: 100%;
    /* color: ${props => props.theme.color.secondaryTextColor}; */
    display: flex;
    justify-content: flex-end;
    text-align: right;
    align-items: center;
    font-size: ${rem(14)};

    .suggestion-icon {
      transform: rotate(225deg);
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Components/AlgoliaSearch/index.js